import { CardTypesEnum, ProcessingRuleItem } from '@common-fe/common-fe';

import { OptionKey } from '@/common/types';
import { IIdNameDto, IPayoutDefinitionDto } from '@/dtos';

export type PayoutDefinitionByIdResponse = IPayoutDefinitionDto;
export type PayoutDefinitionLiteResponse = IIdNameDto;

export interface ExpandedItemLevel {
  title: string;
  subTitle: string;
  subSubTitle?: string;
}

export interface EnrollmentFilterParams {
  planTemplate?: OptionKey;
  planYear?: OptionKey;
  enrollmentDate?: string;
}

export interface ExpandedThirdLevelObject {
  id?: string;
  blockTitle?: string;
  title: string;
  subTitle?: string;
  subSubTitle?: string;
  triggers?: string[];
  items?: string[];
  header?: string[];
  values?: string[];
}

export interface EnrollmentMatrixItem {
  id: string;
  name: string;
  organizationType: string;
  isHealthPlanDelimiter?: boolean;
  planTemplate?: {
    id: string;
    name: string;
  };
  planYear?: {
    id: string;
    name: string;
  };
  processingRule?: ProcessingRuleItem;
  validFrom: string;
  validTo: string;
  priority: string;
  isLinkToHealthPlan: boolean;
}

export enum TriggerEnum {
  EXTERNAL_DEDUCTIBLE_MET = 'EXTERNAL_DEDUCTIBLE_MET',
}

export interface SearchEnrollmentMatrixParams {
  name?: string;
  page?: number;
  size?: number;
  sort?: string;
  filterParams?: EnrollmentFilterParams;
}

export interface PayoutDefinitionResponse {
  id: number;
  name: string;
  categories: CategoryTypesResponse[];
  is_limited_use?: boolean;
  organization_type?: string;
}

export interface CategoryTypesResponse {
  category_type: string;
  services?: CategoryService[];
}

export interface PlanResponse {
  id: string;
  name: string;
  account_type?: string;
  order: number;
}

export interface PayoutDefinition {
  id: string;
  name: string;
  isLimited?: boolean;
  canBeLimited?: boolean;
  mpTableId?: string;
  covTableId?: string;
  organizationType?: string;
  organizationPath?: string;
  categoryTypes?: CategoryType[];
  categoryTypesStrings?: string[];
}

export interface CategoryService {
  id: string;
  name: string;
  serviceType?: string;
  sequenceId?: number;
  plans?: Plan[];
  planNames?: string[];
}

export interface CategoryType {
  categoryType?: string;
  services?: CategoryService[];
}

export interface Plan {
  id: string;
  name: string;
  accountType: CardTypesEnum;
  order: number;
}

export const BASED_ON_NONE_KEY = 'basedOnNone';
